import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
   faClock,
   faCalendar,
   faArrowLeftLong,
   faPeopleGroup,
   faComments,
   faEllipsisVertical,
   faPen,
   faBan,
   faXmark,
   faX,
   faCheck,
} from '@fortawesome/free-solid-svg-icons'
import { useContext, useState } from 'react'
import GeneralContext from '../contexts/GeneralContext'
import { useEffect } from 'react'
import { AnimatePresence, motion } from 'framer-motion'

function ActivityCard({
   name,
   img_link,
   time,
   activity,
   location,
   status,
   date,
   start_time,
   start_date,
   activityID,
   authorID,
}) {
   const {
      showParticipants,
      setShowParticipants,
      participantsHome,
      setParticipantsHome,
      get_activity,
      get_userInfoByID,
      showFullSize,
      showComments,
      setShowComments,
      comments,
      setComments,
      commentActivityID,
      setCommentActivityID,
      ignorePointer,
      hideOptions,
   } = useContext(GeneralContext)

   const [isJoined, setIsJoined] = useState(false)
   const [editMode, setEditMode] = useState(false)
   const [state_date_start, setState_date_start] = useState(start_date)
   const [state_date_end, setState_date_end] = useState(date)
   const [state_time_start, setState_time_start] = useState(start_time)
   const [state_time_end, setState_time_end] = useState(time)
   const [showDropdown, setShowDropdown] = useState(false)

   const convertToMilitary = (time) => {
      if (!time) {
         return '00:00'
      }
      const AmPm = time.slice(-2)
      let hour = null
      let mins = null
      if (AmPm == 'PM') {
         hour = parseInt(time.split(':')[0]) + 12
         if (hour == 24) {
            hour = '12'
         }
         hour = hour.toString()
      } else {
         hour = time.split(':')[0]
         if (hour == '12') {
            hour = '0'
         }
      }
      mins = time.split(':')[1]
      mins = mins.slice(0, 2)

      return hour + ':' + mins
   }

   const convertToPmAm = (time) => {
      var split_time = time.split(':')
      var build = ''
      var hour = 0

      if (parseInt(split_time[0]) > 12) {
         hour = parseInt(split_time[0]) - 12
         build = hour.toString() + ':' + split_time[1] + ' PM'
      } else if (parseInt(split_time[0]) == 0) {
         build = '12:' + split_time[1] + ' AM'
      } else if (parseInt(split_time[0]) == 12) {
         build = '12:' + split_time[1] + ' PM'
      } else {
         build = split_time[0] + ':' + split_time[1] + ' AM'
      }

      return build
   }

   const convertToSlashes = (date) => {
      let data = date.split('-')
      let retval = ''
      retval += data[1] + '/'
      retval += data[2] + '/'
      retval += data[0]
      return retval
   }

   const convertToDashes = (date) => {
      let data = date.split('/')
      let retval = ''
      retval += data[2] + '-'
      retval += data[0] + '-'
      retval += data[1]
      return retval
   }

   useEffect(async () => {
      const activity = await get_activity(activityID)
      const participants = activity.attributes.participants
      for (let participant of participants) {
         if (participant.id == sessionStorage.getItem('user')) {
            setIsJoined(true)
         }
      }
   }, [])

   const resetValues = () => {
      setState_time_start(convertToMilitary(start_time))
      setState_time_end(convertToMilitary(time))
      setState_date_start(convertToDashes(start_date))
      setState_date_end(convertToDashes(date))
   }

   useEffect(() => {
      resetValues()
   }, [])

   const showParticipantsFunc = async (activityID) => {
      //const test_activityID = 24
      const activity = await get_activity(activityID)
      const participants = activity.attributes.participants
      setParticipantsHome(participants)
      setShowParticipants(true)
      setShowComments(false)
   }

   const showCommentsFunc = async (activityID) => {
      const activity = await get_activity(activityID)
      const comments = activity.reactions
      console.log('Loaded comments', comments)
      setComments(comments)
      setShowComments(true)
      setCommentActivityID(activityID)
      setShowParticipants(false)
   }

   const joinActivity = async (activityID) => {
      //const test_activityID = 24
      const activity_data = await get_activity(activityID)
      const user_info = await get_userInfoByID(sessionStorage.getItem('user'))
      const ret_obj = {
         id: sessionStorage.getItem('user'),
         username: user_info.attributes.username,
         profile_pic_src: user_info.attributes.profile_pic_src,
         name: user_info.attributes.name,
      }
      activity_data.attributes.participants.push(ret_obj)
      const ret_activity = JSON.stringify({
         authorID: activity_data.authorID,
         content: activity_data.content,
         attributes: activity_data.attributes,
      })
      return fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/posts/' +
            activityID,
         {
            method: 'PATCH',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: ret_activity,
         }
      )
         .then((res) => res.json())
         .then(
            (result) => {
               setIsJoined(true)
               console.log(result)
            },
            (error) => {
               console.log('error: no activity found')
            }
         )
   }

   const blockActivity = async (activityID) => {
      //const test_activityID = 24
      const activity_data = await get_activity(activityID)
      activity_data.attributes.blockedBy.push(sessionStorage.getItem('user'))
      const ret_activity = JSON.stringify({
         authorID: activity_data.authorID,
         content: activity_data.content,
         attributes: activity_data.attributes,
      })
      return fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/posts/' +
            activityID,
         {
            method: 'PATCH',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: ret_activity,
         }
      )
         .then((res) => res.json())
         .then(
            (result) => {
               //setIsJoined(true)
               console.log(result)
            },
            (error) => {
               console.log('error: no activity found')
            }
         )
   }

   const deletePost = async () => {
      return fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/posts/' +
            activityID,
         {
            method: 'DELETE',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
         }
      )
         .then((res) => res.json())
         .then((result) => {
            if (result) {
               return result
            }
         })
   }

   const editPost = async () => {
      setEditMode(true)
   }

   const updateData = async () => {
      const activity_data = await get_activity(activityID)
      const ret_activity = JSON.stringify({
         authorID: activity_data.authorID,
         content: activity_data.content,
         attributes: {
            ...activity_data.attributes,
            ['startTime']: state_time_start,
            ['endTime']: state_time_end,
            ['date']: convertToSlashes(state_date_start),
            ['end_date']: convertToSlashes(state_date_end),
         },
      })
      fetch(
         'https://webdev.cse.buffalo.edu/hci/api/api/deekstra' +
            '/posts/' +
            activityID,
         {
            method: 'PATCH',
            headers: {
               'Content-Type': 'application/json',
               Authorization: 'Bearer ' + sessionStorage.getItem('token'),
            },
            body: ret_activity,
         }
      )
         .then((res) => res.json())
         .then((result) => {
            setEditMode(false)
         })
         .catch((error) => {
            console.log('error: ', error)
         })
   }

   // const fullSizeCard = (
   //    <div className="profile_activityCard">
   //       <div className="activityCard_avatar">
   //          <img
   //             className="activityCard_avatar_image"
   //             src={img_link}
   //             alt="avatar"
   //          />
   //       </div>
   //       <div className="activityCard_description">
   //          <div className="activityCard_description_top">
   //             <p className="activityCard_description_top_name">
   //                {!editMode && name}
   //             </p>

   //             <div className="activityCard_description_top_dateIdentifier">
   //                Starts:
   //             </div>
   //             <div className="activityCard_description_top_time">
   //                <FontAwesomeIcon icon={faClock} />
   //                <div className="activityCard_description_top_time_p">
   //                   {!editMode ? (
   //                      start_time
   //                   ) : (
   //                      <input
   //                         type="time"
   //                         className="activityCard_input_Time"
   //                         value={state_time_start}
   //                         onChange={(e) => {
   //                            e.preventDefault()
   //                            setState_time_start(e.target.value)
   //                         }}
   //                      />
   //                   )}
   //                </div>
   //             </div>
   //             <div className="activityCard_description_top_time">
   //                <FontAwesomeIcon icon={faCalendar} />
   //                <div className="activityCard_description_top_time_p">
   //                   {!editMode ? (
   //                      start_date
   //                   ) : (
   //                      <input
   //                         type="date"
   //                         className="activityCard_input_Date"
   //                         value={state_date_start}
   //                         onChange={(e) => {
   //                            e.preventDefault()
   //                            // console.log(e.target.value)
   //                            // console.log(convertToSlashes(e.target.value))
   //                            setState_date_start(e.target.value)
   //                         }}
   //                      />
   //                   )}
   //                </div>
   //             </div>
   //             <div className="activityCard_description_top_dateIdentifier">
   //                Ends:
   //             </div>
   //             <div className="activityCard_description_top_time">
   //                <FontAwesomeIcon icon={faClock} />
   //                <div className="activityCard_description_top_time_p">
   //                   {!editMode ? (
   //                      time
   //                   ) : (
   //                      <input
   //                         type="time"
   //                         className="activityCard_input_Time"
   //                         value={state_time_end}
   //                         onChange={(e) => {
   //                            e.preventDefault()
   //                            setState_time_end(e.target.value)
   //                         }}
   //                      />
   //                   )}
   //                </div>
   //             </div>
   //             <div className="activityCard_description_top_time">
   //                <FontAwesomeIcon icon={faCalendar} />
   //                <div className="activityCard_description_top_time_p">
   //                   {!editMode ? (
   //                      date
   //                   ) : (
   //                      <input
   //                         type="date"
   //                         className="activityCard_input_Date"
   //                         value={state_date_end}
   //                         onChange={(e) => {
   //                            e.preventDefault()
   //                            setState_date_end(e.target.value)
   //                         }}
   //                      />
   //                   )}
   //                </div>
   //             </div>
   //          </div>

   //          <div className="activityCard_description_middle">
   //             {activity} at {location}
   //          </div>
   //          <div className="activityCard_description_bottom">
   //             {authorID == sessionStorage.getItem('user') &&
   //                status != 'past' &&
   //                !editMode && (
   //                   <div className="removePostButton" onClick={editPost}>
   //                      Edit
   //                   </div>
   //                )}
   //             {authorID == sessionStorage.getItem('user') &&
   //                status != 'past' &&
   //                !editMode && (
   //                   <div className="removePostButton" onClick={deletePost}>
   //                      Delete
   //                   </div>
   //                )}
   //             {authorID != sessionStorage.getItem('user') &&
   //                status != 'past' &&
   //                !editMode && (
   //                <button
   //                   className="removePostButton"
   //                   onClick={() => {
   //                      blockActivity(activityID)
   //                   }}
   //                >
   //                   Block
   //                </button>
   //             )}
   //          </div>
   //       </div>
   //       <div className="activityCard_joinSection">
   //          {authorID != sessionStorage.getItem('user') && !editMode && (
   //             <button
   //                className={
   //                   !isJoined
   //                      ? 'activityCard_joinSection_joinButton'
   //                      : 'activityCard_joinSection_joinButtonGreyed'
   //                }
   //                onClick={() => {
   //                   if (!isJoined) {
   //                      joinActivity(activityID)
   //                   }
   //                }}
   //             >
   //                {isJoined ? 'Joined' : 'Join'}
   //             </button>
   //          )}
   //          {!editMode && (
   //             <button
   //                className="activityCard_joinSection_participantsButton"
   //                onClick={() => {
   //                   showParticipantsFunc(activityID)
   //                }}
   //             >
   //                Participants
   //             </button>
   //          )}
   //          {editMode && (
   //             <button
   //                className="activityCard_joinSection_participantsButton"
   //                onClick={updateData}
   //             >
   //                Confirm
   //             </button>
   //          )}
   //          <button className="activityCard_commentSection_commentButton"
   //                   onClick={() => {
   //                      showCommentsFunc(activityID)
   //                }}>
   //             <FontAwesomeIcon className="comment_icon" icon={faComments} alt="comments"/>
   //          </button>
   //       </div>
   //    </div>
   // )

   const fullSizeCard = (
      <motion.div
         className={`${
            'profile_activityCard' +
            (editMode ? ' profile_activityCardSmall_editMode' : '')
         }`}
         // key="1"
         initial={{ opacity: 0 }}
         animate={{ opacity: 1 }}
         transition={{ delay: 0.1, duration: 0.25 }}
      >
         <div className="activityCard_avatar">
            <img
               className="activityCard_avatar_image"
               src={img_link}
               alt="avatar"
            />
         </div>
         <div className="activityCard_description">
            <div className="activityCard_description_top">
               <p className="activityCard_description_top_name">
                  {!editMode && name}
               </p>
               <div className="activityCard_description_top_info_section">
                  <div className="activityCard_description_top_info">
                     <div className="activityCard_description_top_start">
                        <div className="activityCard_description_top_dateIdentifier">
                           Starts:
                        </div>
                        <div className="activityCard_description_top_startBlockInfo">
                           <div className="activityCard_description_top_time">
                              <FontAwesomeIcon icon={faCalendar} />
                              <div className="activityCard_description_top_time_p">
                                 {!editMode ? (
                                    start_date
                                 ) : (
                                    <input
                                       type="date"
                                       className="activityCard_input_Date"
                                       value={state_date_start}
                                       onChange={(e) => {
                                          e.preventDefault()
                                          // console.log(e.target.value)
                                          // console.log(convertToSlashes(e.target.value))
                                          setState_date_start(e.target.value)
                                       }}
                                    />
                                 )}
                              </div>
                           </div>
                           <div className="activityCard_description_top_time">
                              <FontAwesomeIcon icon={faClock} />
                              <div className="activityCard_description_top_time_p">
                                 {!editMode ? (
                                    start_time
                                 ) : (
                                    <input
                                       type="time"
                                       className="activityCard_input_Time"
                                       value={state_time_start}
                                       onChange={(e) => {
                                          e.preventDefault()
                                          setState_time_start(e.target.value)
                                       }}
                                    />
                                 )}
                              </div>
                           </div>
                        </div>
                     </div>
                     <div className="activityCard_border_info"></div>
                     <div className="activityCard_description_top_end">
                        <div className="activityCard_description_top_dateIdentifier">
                           Ends:
                        </div>
                        <div className="activityCard_description_top_endBlockInfo">
                           <div className="activityCard_description_top_time">
                              <FontAwesomeIcon icon={faCalendar} />
                              <div className="activityCard_description_top_time_p">
                                 {!editMode ? (
                                    date
                                 ) : (
                                    <input
                                       type="date"
                                       className="activityCard_input_Date"
                                       value={state_date_end}
                                       onChange={(e) => {
                                          e.preventDefault()
                                          setState_date_end(e.target.value)
                                       }}
                                    />
                                 )}
                              </div>
                           </div>
                           <div className="activityCard_description_top_time">
                              <FontAwesomeIcon icon={faClock} />
                              <div className="activityCard_description_top_time_p">
                                 {!editMode ? (
                                    time
                                 ) : (
                                    <input
                                       type="time"
                                       className="activityCard_input_Time"
                                       value={state_time_end}
                                       onChange={(e) => {
                                          e.preventDefault()
                                          setState_time_end(e.target.value)
                                       }}
                                    />
                                 )}
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
               <div className="activityCard_divExtraButton">
                  <FontAwesomeIcon
                     icon={faEllipsisVertical}
                     className="activityCardSmall_extraButton"
                     onClick={() => {
                        setShowDropdown(!showDropdown)
                     }}
                  />
                  <div className="activityCardSmall_extraButton_dropdown">
                     {authorID == sessionStorage.getItem('user') &&
                        status != 'past' &&
                        !editMode && (
                           <div
                              className={`${
                                 showDropdown
                                    ? 'activityCardSmall_extraButton_dropdown_button_shown'
                                    : 'activityCardSmall_extraButton_dropdown_button_hidden'
                              }`}
                              onClick={() => {
                                 setEditMode(!editMode)
                                 setShowDropdown(false)
                              }}
                           >
                              <FontAwesomeIcon
                                 icon={faPen}
                                 className="activityCardSmall_extraButton_dropdown_button_icon"
                              />
                              Edit
                           </div>
                        )}
                     {authorID == sessionStorage.getItem('user') &&
                        status != 'past' && (
                           <div
                              className={`${
                                 showDropdown
                                    ? 'activityCardSmall_extraButton_dropdown_button_shown'
                                    : 'activityCardSmall_extraButton_dropdown_button_hidden'
                              }`}
                              onClick={() => {
                                 deletePost()
                                 setShowDropdown(false)
                              }}
                           >
                              <FontAwesomeIcon
                                 icon={faXmark}
                                 className="activityCardSmall_extraButton_dropdown_button_icon icon_large"
                              />
                              Delete
                           </div>
                        )}
                     {!editMode && authorID != sessionStorage.getItem('user') && (
                        <div
                           className={`${
                              showDropdown
                                 ? 'activityCardSmall_extraButton_dropdown_button_shown'
                                 : 'activityCardSmall_extraButton_dropdown_button_hidden'
                           }`}
                        >
                           <FontAwesomeIcon
                              icon={faBan}
                              className="activityCardSmall_extraButton_dropdown_button_icon"
                           />
                           Block
                        </div>
                     )}
                  </div>
               </div>
            </div>

            <div className="activityCard_description_middle">
               {activity} at {location}
            </div>
            <div className="activityCard_description_bottom">
               {!editMode ? (
                  <div className="activityCardSmall_bottom">
                     <div className="activityCardSmall_bottom_button">
                        <FontAwesomeIcon
                           className="activityCardSmall_bottomButton"
                           icon={faPeopleGroup}
                           onClick={() => {
                              showParticipantsFunc(activityID)
                           }}
                        />
                     </div>
                     <div className="activityCardSmall_border_button"></div>
                     <div className="activityCardSmall_bottom_button">
                        <FontAwesomeIcon
                           className="activityCardSmall_bottomButton"
                           icon={faComments}
                           onClick={() => {
                              showCommentsFunc(activityID)
                           }}
                        />
                     </div>
                     <div className="activityCardSmall_border_button"></div>
                     <div className="activityCardSmall_bottom_button">
                        <FontAwesomeIcon
                           className={`${
                              !isJoined &&
                              authorID != sessionStorage.getItem('user')
                                 ? 'activityCardSmall_bottomButton'
                                 : 'activityCardSmall_bottomButton_greyed'
                           }`}
                           icon={faArrowLeftLong}
                           onClick={() => {
                              if (!isJoined) {
                                 joinActivity(activityID)
                              }
                           }}
                        />
                     </div>
                  </div>
               ) : (
                  <div className="activityCardSmall_bottom">
                     <div className="activityCardSmall_bottom_button">
                        <FontAwesomeIcon
                           className="activityCardSmall_bottomButton_X"
                           icon={faX}
                           onClick={() => {
                              setEditMode(!editMode)
                              resetValues()
                           }}
                        />
                     </div>
                     <div className="activityCardSmall_border_button"></div>
                     <div className="activityCardSmall_bottom_button">
                        <FontAwesomeIcon
                           className="activityCardSmall_bottomButton"
                           icon={faCheck}
                           onClick={updateData}
                        />
                     </div>
                  </div>
               )}
            </div>
         </div>
         {/* <div className="activityCard_joinSection">
            {authorID != sessionStorage.getItem('user') && !editMode && (
               <button
                  className={
                     !isJoined
                        ? 'activityCard_joinSection_joinButton'
                        : 'activityCard_joinSection_joinButtonGreyed'
                  }
                  onClick={() => {
                     if (!isJoined) {
                        joinActivity(activityID)
                     }
                  }}
               >
                  {isJoined ? 'Joined' : 'Join'}
               </button>
            )}
            {!editMode && (
               <button
                  className="activityCard_joinSection_participantsButton"
                  onClick={() => {
                     showParticipantsFunc(activityID)
                  }}
               >
                  Participants
               </button>
            )}
            {editMode && (
               <button
                  className="activityCard_joinSection_participantsButton"
                  onClick={updateData}
               >
                  Confirm
               </button>
            )}
            <button className="activityCard_commentSection_commentButton" 
                     onClick={() => {
                        showCommentsFunc(activityID)
                  }}> 
               <FontAwesomeIcon className="comment_icon" icon={faComments} alt="comments"/>
            </button>
         </div> */}
      </motion.div>
   )

   const smallSizeCard = (
      <div
         className={`${
            'profile_activityCardSmall' +
            (editMode ? ' profile_activityCardSmall_editMode' : '') +
            (ignorePointer ? ' ignorePointer' : '')
         }`}
      >
         <div className="activityCardSmall_extra">
            <div className="activityCardSmall_divExtraButton">
               <FontAwesomeIcon
                  icon={faEllipsisVertical}
                  className={!hideOptions ? "activityCardSmall_extraButton" : "activityCardSmall_extraButton transparent"}
                  onClick={() => {
                     setShowDropdown(!showDropdown)
                  }}
               />
               <div className="activityCardSmall_extraButton_dropdown">
                  {authorID == sessionStorage.getItem('user') &&
                     status != 'past' &&
                     !editMode && (
                        <div
                           className={`${
                              showDropdown
                                 ? 'activityCardSmall_extraButton_dropdown_button_shown'
                                 : 'activityCardSmall_extraButton_dropdown_button_hidden'
                           }`}
                           onClick={() => {
                              setEditMode(!editMode)
                              setShowDropdown(false)
                           }}
                        >
                           <FontAwesomeIcon
                              icon={faPen}
                              className="activityCardSmall_extraButton_dropdown_button_icon"
                           />
                           Edit
                        </div>
                     )}
                  {authorID == sessionStorage.getItem('user') &&
                     status != 'past' && (
                        <div
                           className={`${
                              showDropdown
                                 ? 'activityCardSmall_extraButton_dropdown_button_shown'
                                 : 'activityCardSmall_extraButton_dropdown_button_hidden'
                           }`}
                           onClick={() => {
                              deletePost()
                              setShowDropdown(false)
                           }}
                        >
                           <FontAwesomeIcon
                              icon={faXmark}
                              className="activityCardSmall_extraButton_dropdown_button_icon icon_large"
                           />
                           Delete
                        </div>
                     )}
                  {!editMode && authorID != sessionStorage.getItem('user') && (
                     <div
                        className={`${
                           showDropdown
                              ? 'activityCardSmall_extraButton_dropdown_button_shown'
                              : 'activityCardSmall_extraButton_dropdown_button_hidden'
                        }`}
                     >
                        <FontAwesomeIcon
                           icon={faBan}
                           className="activityCardSmall_extraButton_dropdown_button_icon"
                        />
                        Block
                     </div>
                  )}
               </div>
            </div>
         </div>
         <div className="activityCardSmall_main">
            <div className="activityCardSmall_avatar">
               <img
                  className="activityCardSmall_avatar_image"
                  src={img_link}
                  alt="avatar"
               />
               <h1 className="activityCardSmall_name">{name}</h1>
            </div>
            <div className="profile_activityCardSmall_info">
               <div className="profile_activityCardSmall_top">
                  <div className="activityCardSmall_startDate">
                     <h1 className="activityCardSmall_date_info">Start</h1>
                     <div className="activityCardSmall_date">
                        <FontAwesomeIcon
                           icon={faCalendar}
                           className="activityCardSmall_dateIcon"
                        />
                        {!editMode ? (
                           start_date
                        ) : (
                           <input
                              type="date"
                              className="activityCard_input_Date"
                              value={state_date_start}
                              onChange={(e) => {
                                 e.preventDefault()
                                 console.log(e.target.value)
                                 console.log(convertToSlashes(e.target.value))
                                 setState_date_start(e.target.value)
                              }}
                           />
                        )}
                     </div>
                     <div className="activityCardSmall_time">
                        <FontAwesomeIcon
                           icon={faClock}
                           className="activityCardSmall_dateIcon"
                        />
                        {!editMode ? (
                           start_time
                        ) : (
                           <input
                              type="time"
                              className="activityCard_input_Time"
                              value={state_time_start}
                              onChange={(e) => {
                                 e.preventDefault()
                                 setState_time_start(e.target.value)
                              }}
                           />
                        )}
                     </div>
                  </div>
                  <div className="activityCardSmall_endDate">
                     <h1 className="activityCardSmall_date_info">End</h1>
                     <div className="activityCardSmall_date">
                        <FontAwesomeIcon
                           icon={faCalendar}
                           className="activityCardSmall_dateIcon"
                        />
                        {!editMode ? (
                           date
                        ) : (
                           <input
                              type="date"
                              className="activityCard_input_Date"
                              value={state_date_end}
                              onChange={(e) => {
                                 e.preventDefault()
                                 setState_date_end(e.target.value)
                              }}
                           />
                        )}
                     </div>
                     <div className="activityCardSmall_time">
                        <FontAwesomeIcon
                           className="activityCardSmall_dateIcon"
                           icon={faClock}
                        />
                        {!editMode ? (
                           time
                        ) : (
                           <input
                              type="time"
                              className="activityCard_input_Time"
                              value={state_time_end}
                              onChange={(e) => {
                                 e.preventDefault()
                                 setState_time_end(e.target.value)
                              }}
                           />
                        )}
                     </div>
                  </div>
               </div>
               <div className="profile_activityCardSmall_bottom">
                  <div className="activityCardSmall_bottom_text">
                     {activity} at {location}
                  </div>
               </div>
            </div>
         </div>
         {/* <div className='activityCardSmall_border'></div> */}
         {!editMode ? (
            <div className="activityCardSmall_bottom">
               <div className="activityCardSmall_bottom_button">
                  <FontAwesomeIcon
                     className="activityCardSmall_bottomButton"
                     icon={faPeopleGroup}
                     onClick={() => {
                        showParticipantsFunc(activityID)
                     }}
                  />
               </div>
               <div className="activityCardSmall_border_button"></div>
               <div className="activityCardSmall_bottom_button">
                  <FontAwesomeIcon
                     className="activityCardSmall_bottomButton"
                     icon={faComments}
                     onClick={() => {
                        showCommentsFunc(activityID)
                     }}
                  />
               </div>
               <div className="activityCardSmall_border_button"></div>
               <div className="activityCardSmall_bottom_button">
                  <FontAwesomeIcon
                     className={`${
                        !isJoined && authorID != sessionStorage.getItem('user')
                           ? 'activityCardSmall_bottomButton'
                           : 'activityCardSmall_bottomButton_greyed'
                     }`}
                     icon={faArrowLeftLong}
                     onClick={() => {
                        if (!isJoined) {
                           joinActivity(activityID)
                        }
                     }}
                  />
               </div>
            </div>
         ) : (
            <div className="activityCardSmall_bottom">
               <div className="activityCardSmall_bottom_button">
                  <FontAwesomeIcon
                     className="activityCardSmall_bottomButton_X"
                     icon={faX}
                     onClick={() => {
                        setEditMode(!editMode)
                        resetValues()
                     }}
                  />
               </div>
               <div className="activityCardSmall_border_button"></div>
               <div className="activityCardSmall_bottom_button">
                  <FontAwesomeIcon
                     className="activityCardSmall_bottomButton"
                     icon={faCheck}
                     onClick={updateData}
                  />
               </div>
            </div>
         )}
      </div>
   )

   if (!showFullSize) {
      return smallSizeCard
   }

   return fullSizeCard
}

export default ActivityCard

ActivityCard.defaultProps = {
   name: 'Firstname Lastname',
   img_link: 'https://api.lorem.space/image/face?hash=92048',
   time: 'xx:xx PM',
   activity: 'Activity name here',
   location: 'Location',
   status: 'now',
   date: 'xx/xx/xxxx',
   start_time: 'xx:xx',
   start_date: 'xx/xx/xxxx',
}
